import { EXCLUDED_DIRECTIONS } from "../constants/ExcludedDirections";

export default function InExcludedDirections(oper, depart, country, region) {
  let oper_directions = EXCLUDED_DIRECTIONS[oper];
  if (oper_directions) {
    if (
      oper_directions['null-' + depart + '-[]'] ||
      oper_directions[country + '-null-[]'] ||
      oper_directions[country + '-' + depart + '-[]']
    ) {
      return true;
    }
    for (let key in oper_directions) {
      let array_exclude_region_id;
      let full_array = key.split('-');
      let array_exclude = full_array[2];
      try {
        array_exclude_region_id = JSON.parse(array_exclude);
        let exc_true = array_exclude_region_id.indexOf(parseInt(region)) >= 0;
        if (
          (full_array[0] == 'null' && full_array[1] == depart && exc_true) ||
          (full_array[0] == country && full_array[1] == 'null' && exc_true) ||
          (full_array[0] == country && full_array[1] == depart && exc_true)
        ) {
          return true;
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
  return false;
}